export const includesIgnoreCase = (data: readonly string[], value: string) =>
  data.some((item) => item.toLowerCase() === value.toLowerCase())
